import type { ChangeEvent } from "react";
import { useMemo } from "react";
import { debounce } from "lodash";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { isValidURL } from "@/react/helpers/urlHelpers/isValidUrl";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Form } from "@circle-react-uikit/Form";
import { FormItemWrapper } from "../../DefaultEditorV2/FormItemWrapper";

export interface UrlFieldProps {
  label: string;
  name: string;
}

export const UrlField = ({ name, label }: UrlFieldProps) => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();
  const { setError } = useFormContext();

  const debouncedValidateUrl = useMemo(
    () =>
      debounce((url: string) => {
        if (isValidURL(url)) {
          return;
        }
        setError(name, {
          type: "manual",
          message: t("builder_ui.prop_type.errors.invalid_url"),
        });
      }, 1000),
    [name, setError],
  );

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const url = event.target.value;
    debouncedValidateUrl(url);
  };

  if (isPropertiesPanelV2) {
    return (
      <Form.Item
        name={name}
        label={label}
        hideDescription
        hideBorder
        placeholder={t("builder_ui.prop_type.url_placeholder")}
        labelClassName="!font-normal text-xs"
        childrenWrapper={FormItemWrapper}
        className="!p-0"
      >
        <Form.Input type="url" name={name} onChange={onChangeHandler} />
      </Form.Item>
    );
  }

  return (
    <Form.Item
      name={name}
      label={label}
      hideDescription
      hideBorder
      labelClassName="!font-normal text-xs"
      className="!p-0"
      placeholder={t("builder_ui.prop_type.url_placeholder")}
    >
      <Form.Input type="url" name={name} onChange={onChangeHandler} />
    </Form.Item>
  );
};
